import { ref, computed, watch, onMounted, onUnmounted } from "vue";

const COUNTRIES = [
	// ── Europe ──────────────────────────────────────────────────────────────
	{ code: "AL", dialCode: "+355", flag: "🇦🇱", name: "Albania", min: 9, max: 9 },
	{ code: "AD", dialCode: "+376", flag: "🇦🇩", name: "Andorra", min: 6, max: 9 },
	{
		code: "AT",
		dialCode: "+43",
		flag: "🇦🇹",
		name: "Austria",
		min: 10,
		max: 11,
	},
	{ code: "BY", dialCode: "+375", flag: "🇧🇾", name: "Belarus", min: 9, max: 9 },
	{ code: "BE", dialCode: "+32", flag: "🇧🇪", name: "Belgium", min: 8, max: 9 },
	{
		code: "BA",
		dialCode: "+387",
		flag: "🇧🇦",
		name: "Bosnia & Herzegovina",
		min: 8,
		max: 8,
	},
	{
		code: "BG",
		dialCode: "+359",
		flag: "🇧🇬",
		name: "Bulgaria",
		min: 8,
		max: 9,
	},
	{ code: "HR", dialCode: "+385", flag: "🇭🇷", name: "Croatia", min: 8, max: 9 },
	{ code: "CY", dialCode: "+357", flag: "🇨🇾", name: "Cyprus", min: 8, max: 8 },
	{
		code: "CZ",
		dialCode: "+420",
		flag: "🇨🇿",
		name: "Czech Republic",
		min: 9,
		max: 9,
	},
	{ code: "DK", dialCode: "+45", flag: "🇩🇰", name: "Denmark", min: 8, max: 8 },
	{ code: "EE", dialCode: "+372", flag: "🇪🇪", name: "Estonia", min: 7, max: 8 },
	{
		code: "FI",
		dialCode: "+358",
		flag: "🇫🇮",
		name: "Finland",
		min: 6,
		max: 10,
	},
	{ code: "FR", dialCode: "+33", flag: "🇫🇷", name: "France", min: 9, max: 9 },
	{
		code: "DE",
		dialCode: "+49",
		flag: "🇩🇪",
		name: "Germany",
		min: 10,
		max: 11,
	},
	{ code: "GR", dialCode: "+30", flag: "🇬🇷", name: "Greece", min: 10, max: 10 },
	{ code: "HU", dialCode: "+36", flag: "🇭🇺", name: "Hungary", min: 9, max: 9 },
	{ code: "IS", dialCode: "+354", flag: "🇮🇸", name: "Iceland", min: 7, max: 7 },
	{ code: "IE", dialCode: "+353", flag: "🇮🇪", name: "Ireland", min: 9, max: 9 },
	{ code: "IT", dialCode: "+39", flag: "🇮🇹", name: "Italy", min: 6, max: 10 },
	{ code: "LV", dialCode: "+371", flag: "🇱🇻", name: "Latvia", min: 8, max: 8 },
	{
		code: "LI",
		dialCode: "+423",
		flag: "🇱🇮",
		name: "Liechtenstein",
		min: 7,
		max: 9,
	},
	{
		code: "LT",
		dialCode: "+370",
		flag: "🇱🇹",
		name: "Lithuania",
		min: 8,
		max: 8,
	},
	{
		code: "LU",
		dialCode: "+352",
		flag: "🇱🇺",
		name: "Luxembourg",
		min: 9,
		max: 9,
	},
	{ code: "MT", dialCode: "+356", flag: "🇲🇹", name: "Malta", min: 8, max: 8 },
	{ code: "MD", dialCode: "+373", flag: "🇲🇩", name: "Moldova", min: 8, max: 8 },
	{ code: "MC", dialCode: "+377", flag: "🇲🇨", name: "Monaco", min: 8, max: 9 },
	{
		code: "ME",
		dialCode: "+382",
		flag: "🇲🇪",
		name: "Montenegro",
		min: 8,
		max: 8,
	},
	{
		code: "NL",
		dialCode: "+31",
		flag: "🇳🇱",
		name: "Netherlands",
		min: 9,
		max: 9,
	},
	{
		code: "MK",
		dialCode: "+389",
		flag: "🇲🇰",
		name: "North Macedonia",
		min: 8,
		max: 8,
	},
	{ code: "NO", dialCode: "+47", flag: "🇳🇴", name: "Norway", min: 8, max: 8 },
	{ code: "PL", dialCode: "+48", flag: "🇵🇱", name: "Poland", min: 9, max: 9 },
	{
		code: "PT",
		dialCode: "+351",
		flag: "🇵🇹",
		name: "Portugal",
		min: 9,
		max: 9,
	},
	{ code: "RO", dialCode: "+40", flag: "🇷🇴", name: "Romania", min: 9, max: 9 },
	{ code: "RU", dialCode: "+7", flag: "🇷🇺", name: "Russia", min: 10, max: 10 },
	{
		code: "SM",
		dialCode: "+378",
		flag: "🇸🇲",
		name: "San Marino",
		min: 6,
		max: 10,
	},
	{ code: "RS", dialCode: "+381", flag: "🇷🇸", name: "Serbia", min: 8, max: 9 },
	{
		code: "SK",
		dialCode: "+421",
		flag: "🇸🇰",
		name: "Slovakia",
		min: 9,
		max: 9,
	},
	{
		code: "SI",
		dialCode: "+386",
		flag: "🇸🇮",
		name: "Slovenia",
		min: 8,
		max: 8,
	},
	{ code: "ES", dialCode: "+34", flag: "🇪🇸", name: "Spain", min: 9, max: 9 },
	{ code: "SE", dialCode: "+46", flag: "🇸🇪", name: "Sweden", min: 7, max: 9 },
	{
		code: "CH",
		dialCode: "+41",
		flag: "🇨🇭",
		name: "Switzerland",
		min: 9,
		max: 9,
	},
	{ code: "UA", dialCode: "+380", flag: "🇺🇦", name: "Ukraine", min: 9, max: 9 },
	{
		code: "GB",
		dialCode: "+44",
		flag: "🇬🇧",
		name: "United Kingdom",
		min: 10,
		max: 10,
	},
	{
		code: "VA",
		dialCode: "+39",
		flag: "🇻🇦",
		name: "Vatican City",
		min: 6,
		max: 10,
	},
	// ── Caucasus & Central Asia ──────────────────────────────────────────────
	{ code: "AM", dialCode: "+374", flag: "🇦🇲", name: "Armenia", min: 8, max: 8 },
	{
		code: "AZ",
		dialCode: "+994",
		flag: "🇦🇿",
		name: "Azerbaijan",
		min: 9,
		max: 9,
	},
	{ code: "GE", dialCode: "+995", flag: "🇬🇪", name: "Georgia", min: 9, max: 9 },
	{
		code: "KZ",
		dialCode: "+7",
		flag: "🇰🇿",
		name: "Kazakhstan",
		min: 10,
		max: 10,
	},
	{
		code: "KG",
		dialCode: "+996",
		flag: "🇰🇬",
		name: "Kyrgyzstan",
		min: 9,
		max: 9,
	},
	{
		code: "TJ",
		dialCode: "+992",
		flag: "🇹🇯",
		name: "Tajikistan",
		min: 9,
		max: 9,
	},
	{
		code: "TM",
		dialCode: "+993",
		flag: "🇹🇲",
		name: "Turkmenistan",
		min: 8,
		max: 8,
	},
	{
		code: "UZ",
		dialCode: "+998",
		flag: "🇺🇿",
		name: "Uzbekistan",
		min: 9,
		max: 9,
	},
	// ── Middle East ──────────────────────────────────────────────────────────
	{
		code: "AF",
		dialCode: "+93",
		flag: "🇦🇫",
		name: "Afghanistan",
		min: 9,
		max: 9,
	},
	{ code: "BH", dialCode: "+973", flag: "🇧🇭", name: "Bahrain", min: 8, max: 8 },
	{ code: "IQ", dialCode: "+964", flag: "🇮🇶", name: "Iraq", min: 10, max: 10 },
	{ code: "IR", dialCode: "+98", flag: "🇮🇷", name: "Iran", min: 10, max: 10 },
	{ code: "IL", dialCode: "+972", flag: "🇮🇱", name: "Israel", min: 9, max: 9 },
	{ code: "JO", dialCode: "+962", flag: "🇯🇴", name: "Jordan", min: 9, max: 9 },
	{ code: "KW", dialCode: "+965", flag: "🇰🇼", name: "Kuwait", min: 8, max: 8 },
	{ code: "LB", dialCode: "+961", flag: "🇱🇧", name: "Lebanon", min: 7, max: 8 },
	{ code: "OM", dialCode: "+968", flag: "🇴🇲", name: "Oman", min: 8, max: 8 },
	{
		code: "PS",
		dialCode: "+970",
		flag: "🇵🇸",
		name: "Palestine",
		min: 9,
		max: 9,
	},
	{ code: "QA", dialCode: "+974", flag: "🇶🇦", name: "Qatar", min: 8, max: 8 },
	{
		code: "SA",
		dialCode: "+966",
		flag: "🇸🇦",
		name: "Saudi Arabia",
		min: 9,
		max: 9,
	},
	{ code: "SY", dialCode: "+963", flag: "🇸🇾", name: "Syria", min: 9, max: 9 },
	{ code: "TR", dialCode: "+90", flag: "🇹🇷", name: "Turkey", min: 10, max: 10 },
	{ code: "AE", dialCode: "+971", flag: "🇦🇪", name: "UAE", min: 9, max: 9 },
	{ code: "YE", dialCode: "+967", flag: "🇾🇪", name: "Yemen", min: 9, max: 9 },
	// ── Asia Pacific ─────────────────────────────────────────────────────────
	{
		code: "BD",
		dialCode: "+880",
		flag: "🇧🇩",
		name: "Bangladesh",
		min: 10,
		max: 10,
	},
	{ code: "BT", dialCode: "+975", flag: "🇧🇹", name: "Bhutan", min: 8, max: 8 },
	{ code: "BN", dialCode: "+673", flag: "🇧🇳", name: "Brunei", min: 7, max: 8 },
	{
		code: "KH",
		dialCode: "+855",
		flag: "🇰🇭",
		name: "Cambodia",
		min: 8,
		max: 9,
	},
	{ code: "CN", dialCode: "+86", flag: "🇨🇳", name: "China", min: 11, max: 11 },
	{
		code: "TL",
		dialCode: "+670",
		flag: "🇹🇱",
		name: "East Timor",
		min: 7,
		max: 8,
	},
	{ code: "FJ", dialCode: "+679", flag: "🇫🇯", name: "Fiji", min: 7, max: 7 },
	{
		code: "HK",
		dialCode: "+852",
		flag: "🇭🇰",
		name: "Hong Kong",
		min: 8,
		max: 8,
	},
	{ code: "IN", dialCode: "+91", flag: "🇮🇳", name: "India", min: 10, max: 10 },
	{
		code: "ID",
		dialCode: "+62",
		flag: "🇮🇩",
		name: "Indonesia",
		min: 9,
		max: 12,
	},
	{ code: "JP", dialCode: "+81", flag: "🇯🇵", name: "Japan", min: 10, max: 11 },
	{
		code: "KI",
		dialCode: "+686",
		flag: "🇰🇮",
		name: "Kiribati",
		min: 8,
		max: 8,
	},
	{
		code: "KP",
		dialCode: "+850",
		flag: "🇰🇵",
		name: "North Korea",
		min: 10,
		max: 10,
	},
	{
		code: "KR",
		dialCode: "+82",
		flag: "🇰🇷",
		name: "South Korea",
		min: 9,
		max: 10,
	},
	{ code: "LA", dialCode: "+856", flag: "🇱🇦", name: "Laos", min: 8, max: 9 },
	{ code: "MO", dialCode: "+853", flag: "🇲🇴", name: "Macau", min: 8, max: 8 },
	{
		code: "MY",
		dialCode: "+60",
		flag: "🇲🇾",
		name: "Malaysia",
		min: 9,
		max: 10,
	},
	{
		code: "MV",
		dialCode: "+960",
		flag: "🇲🇻",
		name: "Maldives",
		min: 7,
		max: 7,
	},
	{
		code: "MH",
		dialCode: "+692",
		flag: "🇲🇭",
		name: "Marshall Islands",
		min: 7,
		max: 7,
	},
	{
		code: "FM",
		dialCode: "+691",
		flag: "🇫🇲",
		name: "Micronesia",
		min: 7,
		max: 7,
	},
	{
		code: "MN",
		dialCode: "+976",
		flag: "🇲🇳",
		name: "Mongolia",
		min: 8,
		max: 8,
	},
	{ code: "MM", dialCode: "+95", flag: "🇲🇲", name: "Myanmar", min: 8, max: 9 },
	{ code: "NR", dialCode: "+674", flag: "🇳🇷", name: "Nauru", min: 7, max: 7 },
	{ code: "NP", dialCode: "+977", flag: "🇳🇵", name: "Nepal", min: 10, max: 10 },
	{
		code: "NZ",
		dialCode: "+64",
		flag: "🇳🇿",
		name: "New Zealand",
		min: 8,
		max: 9,
	},
	{
		code: "PK",
		dialCode: "+92",
		flag: "🇵🇰",
		name: "Pakistan",
		min: 10,
		max: 10,
	},
	{ code: "PW", dialCode: "+680", flag: "🇵🇼", name: "Palau", min: 7, max: 7 },
	{
		code: "PG",
		dialCode: "+675",
		flag: "🇵🇬",
		name: "Papua New Guinea",
		min: 8,
		max: 8,
	},
	{
		code: "PH",
		dialCode: "+63",
		flag: "🇵🇭",
		name: "Philippines",
		min: 10,
		max: 10,
	},
	{ code: "WS", dialCode: "+685", flag: "🇼🇸", name: "Samoa", min: 7, max: 7 },
	{
		code: "SG",
		dialCode: "+65",
		flag: "🇸🇬",
		name: "Singapore",
		min: 8,
		max: 8,
	},
	{
		code: "SB",
		dialCode: "+677",
		flag: "🇸🇧",
		name: "Solomon Islands",
		min: 7,
		max: 7,
	},
	{
		code: "LK",
		dialCode: "+94",
		flag: "🇱🇰",
		name: "Sri Lanka",
		min: 9,
		max: 9,
	},
	{ code: "TW", dialCode: "+886", flag: "🇹🇼", name: "Taiwan", min: 9, max: 10 },
	{ code: "TH", dialCode: "+66", flag: "🇹🇭", name: "Thailand", min: 9, max: 9 },
	{ code: "TO", dialCode: "+676", flag: "🇹🇴", name: "Tonga", min: 7, max: 7 },
	{ code: "TV", dialCode: "+688", flag: "🇹🇻", name: "Tuvalu", min: 6, max: 6 },
	{ code: "VU", dialCode: "+678", flag: "🇻🇺", name: "Vanuatu", min: 7, max: 7 },
	{ code: "VN", dialCode: "+84", flag: "🇻🇳", name: "Vietnam", min: 9, max: 10 },
	{
		code: "AU",
		dialCode: "+61",
		flag: "🇦🇺",
		name: "Australia",
		min: 9,
		max: 9,
	},
	// ── Africa ───────────────────────────────────────────────────────────────
	{ code: "DZ", dialCode: "+213", flag: "🇩🇿", name: "Algeria", min: 9, max: 9 },
	{ code: "AO", dialCode: "+244", flag: "🇦🇴", name: "Angola", min: 9, max: 9 },
	{ code: "BJ", dialCode: "+229", flag: "🇧🇯", name: "Benin", min: 8, max: 8 },
	{
		code: "BW",
		dialCode: "+267",
		flag: "🇧🇼",
		name: "Botswana",
		min: 8,
		max: 8,
	},
	{
		code: "BF",
		dialCode: "+226",
		flag: "🇧🇫",
		name: "Burkina Faso",
		min: 8,
		max: 8,
	},
	{ code: "BI", dialCode: "+257", flag: "🇧🇮", name: "Burundi", min: 8, max: 8 },
	{
		code: "CV",
		dialCode: "+238",
		flag: "🇨🇻",
		name: "Cabo Verde",
		min: 7,
		max: 7,
	},
	{
		code: "CM",
		dialCode: "+237",
		flag: "🇨🇲",
		name: "Cameroon",
		min: 9,
		max: 9,
	},
	{
		code: "CF",
		dialCode: "+236",
		flag: "🇨🇫",
		name: "Central African Rep.",
		min: 8,
		max: 8,
	},
	{ code: "TD", dialCode: "+235", flag: "🇹🇩", name: "Chad", min: 8, max: 8 },
	{ code: "KM", dialCode: "+269", flag: "🇰🇲", name: "Comoros", min: 7, max: 7 },
	{ code: "CG", dialCode: "+242", flag: "🇨🇬", name: "Congo", min: 9, max: 9 },
	{
		code: "CD",
		dialCode: "+243",
		flag: "🇨🇩",
		name: "DR Congo",
		min: 9,
		max: 9,
	},
	{
		code: "DJ",
		dialCode: "+253",
		flag: "🇩🇯",
		name: "Djibouti",
		min: 8,
		max: 8,
	},
	{ code: "EG", dialCode: "+20", flag: "🇪🇬", name: "Egypt", min: 10, max: 10 },
	{
		code: "GQ",
		dialCode: "+240",
		flag: "🇬🇶",
		name: "Equatorial Guinea",
		min: 9,
		max: 9,
	},
	{ code: "ER", dialCode: "+291", flag: "🇪🇷", name: "Eritrea", min: 7, max: 7 },
	{
		code: "SZ",
		dialCode: "+268",
		flag: "🇸🇿",
		name: "Eswatini",
		min: 8,
		max: 8,
	},
	{
		code: "ET",
		dialCode: "+251",
		flag: "🇪🇹",
		name: "Ethiopia",
		min: 9,
		max: 9,
	},
	{ code: "GA", dialCode: "+241", flag: "🇬🇦", name: "Gabon", min: 7, max: 8 },
	{ code: "GM", dialCode: "+220", flag: "🇬🇲", name: "Gambia", min: 7, max: 7 },
	{ code: "GH", dialCode: "+233", flag: "🇬🇭", name: "Ghana", min: 9, max: 9 },
	{ code: "GN", dialCode: "+224", flag: "🇬🇳", name: "Guinea", min: 9, max: 9 },
	{
		code: "GW",
		dialCode: "+245",
		flag: "🇬🇼",
		name: "Guinea-Bissau",
		min: 9,
		max: 9,
	},
	{
		code: "CI",
		dialCode: "+225",
		flag: "🇨🇮",
		name: "Ivory Coast",
		min: 10,
		max: 10,
	},
	{ code: "KE", dialCode: "+254", flag: "🇰🇪", name: "Kenya", min: 9, max: 9 },
	{ code: "LS", dialCode: "+266", flag: "🇱🇸", name: "Lesotho", min: 8, max: 8 },
	{ code: "LR", dialCode: "+231", flag: "🇱🇷", name: "Liberia", min: 7, max: 8 },
	{ code: "LY", dialCode: "+218", flag: "🇱🇾", name: "Libya", min: 9, max: 9 },
	{
		code: "MG",
		dialCode: "+261",
		flag: "🇲🇬",
		name: "Madagascar",
		min: 9,
		max: 9,
	},
	{ code: "MW", dialCode: "+265", flag: "🇲🇼", name: "Malawi", min: 9, max: 9 },
	{ code: "ML", dialCode: "+223", flag: "🇲🇱", name: "Mali", min: 8, max: 8 },
	{
		code: "MR",
		dialCode: "+222",
		flag: "🇲🇷",
		name: "Mauritania",
		min: 8,
		max: 8,
	},
	{
		code: "MU",
		dialCode: "+230",
		flag: "🇲🇺",
		name: "Mauritius",
		min: 8,
		max: 8,
	},
	{ code: "MA", dialCode: "+212", flag: "🇲🇦", name: "Morocco", min: 9, max: 9 },
	{
		code: "MZ",
		dialCode: "+258",
		flag: "🇲🇿",
		name: "Mozambique",
		min: 9,
		max: 9,
	},
	{ code: "NA", dialCode: "+264", flag: "🇳🇦", name: "Namibia", min: 9, max: 9 },
	{ code: "NE", dialCode: "+227", flag: "🇳🇪", name: "Niger", min: 8, max: 8 },
	{
		code: "NG",
		dialCode: "+234",
		flag: "🇳🇬",
		name: "Nigeria",
		min: 10,
		max: 11,
	},
	{ code: "RW", dialCode: "+250", flag: "🇷🇼", name: "Rwanda", min: 9, max: 9 },
	{
		code: "ST",
		dialCode: "+239",
		flag: "🇸🇹",
		name: "São Tomé & Príncipe",
		min: 7,
		max: 7,
	},
	{ code: "SN", dialCode: "+221", flag: "🇸🇳", name: "Senegal", min: 9, max: 9 },
	{
		code: "SC",
		dialCode: "+248",
		flag: "🇸🇨",
		name: "Seychelles",
		min: 7,
		max: 7,
	},
	{
		code: "SL",
		dialCode: "+232",
		flag: "🇸🇱",
		name: "Sierra Leone",
		min: 8,
		max: 8,
	},
	{ code: "SO", dialCode: "+252", flag: "🇸🇴", name: "Somalia", min: 8, max: 8 },
	{
		code: "ZA",
		dialCode: "+27",
		flag: "🇿🇦",
		name: "South Africa",
		min: 9,
		max: 9,
	},
	{
		code: "SS",
		dialCode: "+211",
		flag: "🇸🇸",
		name: "South Sudan",
		min: 9,
		max: 9,
	},
	{ code: "SD", dialCode: "+249", flag: "🇸🇩", name: "Sudan", min: 9, max: 9 },
	{
		code: "TZ",
		dialCode: "+255",
		flag: "🇹🇿",
		name: "Tanzania",
		min: 9,
		max: 9,
	},
	{ code: "TG", dialCode: "+228", flag: "🇹🇬", name: "Togo", min: 8, max: 8 },
	{ code: "TN", dialCode: "+216", flag: "🇹🇳", name: "Tunisia", min: 8, max: 8 },
	{ code: "UG", dialCode: "+256", flag: "🇺🇬", name: "Uganda", min: 9, max: 9 },
	{ code: "ZM", dialCode: "+260", flag: "🇿🇲", name: "Zambia", min: 9, max: 9 },
	{
		code: "ZW",
		dialCode: "+263",
		flag: "🇿🇼",
		name: "Zimbabwe",
		min: 9,
		max: 9,
	},
	// ── Americas ─────────────────────────────────────────────────────────────
	{
		code: "AG",
		dialCode: "+1",
		flag: "🇦🇬",
		name: "Antigua & Barbuda",
		min: 10,
		max: 10,
	},
	{
		code: "AR",
		dialCode: "+54",
		flag: "🇦🇷",
		name: "Argentina",
		min: 10,
		max: 10,
	},
	{ code: "BS", dialCode: "+1", flag: "🇧🇸", name: "Bahamas", min: 10, max: 10 },
	{
		code: "BB",
		dialCode: "+1",
		flag: "🇧🇧",
		name: "Barbados",
		min: 10,
		max: 10,
	},
	{ code: "BZ", dialCode: "+501", flag: "🇧🇿", name: "Belize", min: 7, max: 7 },
	{ code: "BO", dialCode: "+591", flag: "🇧🇴", name: "Bolivia", min: 8, max: 8 },
	{ code: "BR", dialCode: "+55", flag: "🇧🇷", name: "Brazil", min: 10, max: 11 },
	{ code: "CA", dialCode: "+1", flag: "🇨🇦", name: "Canada", min: 10, max: 10 },
	{ code: "CL", dialCode: "+56", flag: "🇨🇱", name: "Chile", min: 9, max: 9 },
	{
		code: "CO",
		dialCode: "+57",
		flag: "🇨🇴",
		name: "Colombia",
		min: 10,
		max: 10,
	},
	{
		code: "CR",
		dialCode: "+506",
		flag: "🇨🇷",
		name: "Costa Rica",
		min: 8,
		max: 8,
	},
	{ code: "CU", dialCode: "+53", flag: "🇨🇺", name: "Cuba", min: 8, max: 8 },
	{
		code: "DM",
		dialCode: "+1",
		flag: "🇩🇲",
		name: "Dominica",
		min: 10,
		max: 10,
	},
	{
		code: "DO",
		dialCode: "+1",
		flag: "🇩🇴",
		name: "Dominican Republic",
		min: 10,
		max: 10,
	},
	{ code: "EC", dialCode: "+593", flag: "🇪🇨", name: "Ecuador", min: 9, max: 9 },
	{
		code: "SV",
		dialCode: "+503",
		flag: "🇸🇻",
		name: "El Salvador",
		min: 8,
		max: 8,
	},
	{ code: "GD", dialCode: "+1", flag: "🇬🇩", name: "Grenada", min: 10, max: 10 },
	{
		code: "GT",
		dialCode: "+502",
		flag: "🇬🇹",
		name: "Guatemala",
		min: 8,
		max: 8,
	},
	{ code: "GY", dialCode: "+592", flag: "🇬🇾", name: "Guyana", min: 7, max: 7 },
	{ code: "HT", dialCode: "+509", flag: "🇭🇹", name: "Haiti", min: 8, max: 8 },
	{
		code: "HN",
		dialCode: "+504",
		flag: "🇭🇳",
		name: "Honduras",
		min: 8,
		max: 8,
	},
	{ code: "JM", dialCode: "+1", flag: "🇯🇲", name: "Jamaica", min: 10, max: 10 },
	{ code: "MX", dialCode: "+52", flag: "🇲🇽", name: "Mexico", min: 10, max: 10 },
	{
		code: "NI",
		dialCode: "+505",
		flag: "🇳🇮",
		name: "Nicaragua",
		min: 8,
		max: 8,
	},
	{ code: "PA", dialCode: "+507", flag: "🇵🇦", name: "Panama", min: 8, max: 8 },
	{
		code: "PY",
		dialCode: "+595",
		flag: "🇵🇾",
		name: "Paraguay",
		min: 9,
		max: 9,
	},
	{ code: "PE", dialCode: "+51", flag: "🇵🇪", name: "Peru", min: 9, max: 9 },
	{
		code: "KN",
		dialCode: "+1",
		flag: "🇰🇳",
		name: "Saint Kitts & Nevis",
		min: 10,
		max: 10,
	},
	{
		code: "LC",
		dialCode: "+1",
		flag: "🇱🇨",
		name: "Saint Lucia",
		min: 10,
		max: 10,
	},
	{
		code: "VC",
		dialCode: "+1",
		flag: "🇻🇨",
		name: "Saint Vincent",
		min: 10,
		max: 10,
	},
	{
		code: "SR",
		dialCode: "+597",
		flag: "🇸🇷",
		name: "Suriname",
		min: 7,
		max: 7,
	},
	{
		code: "TT",
		dialCode: "+1",
		flag: "🇹🇹",
		name: "Trinidad & Tobago",
		min: 10,
		max: 10,
	},
	{
		code: "US",
		dialCode: "+1",
		flag: "🇺🇸",
		name: "United States",
		min: 10,
		max: 10,
	},
	{ code: "UY", dialCode: "+598", flag: "🇺🇾", name: "Uruguay", min: 8, max: 8 },
	{
		code: "VE",
		dialCode: "+58",
		flag: "🇻🇪",
		name: "Venezuela",
		min: 10,
		max: 10,
	},
];

export function usePhoneInput(initialPhoneNumber = "") {
	const selected = ref({
		code: "IT",
		dialCode: "+39",
		flag: "🇮🇹",
		name: "Italy",
		min: 6,
		max: 10,
	});
	const localNumber = ref("");
	const showCountryPicker = ref(false);
	const search = ref("");
	const phoneError = ref("");

	const filtered = computed(() => {
		const q = search.value.toLowerCase().trim();
		if (!q) return COUNTRIES;
		return COUNTRIES.filter(
			(c) =>
				c.name.toLowerCase().includes(q) ||
				c.dialCode.includes(q) ||
				c.code.toLowerCase().includes(q),
		);
	});

	const pick = (country) => {
		selected.value = country;
		showCountryPicker.value = false;
		search.value = "";
	};

	const validate = () => {
		const digits = localNumber.value.replace(/\D/g, "");
		if (!digits) {
			phoneError.value = "";
			return;
		}
		const { min, max, name } = selected.value;
		if (digits.length < min || digits.length > max) {
			const range = min === max ? `${min}` : `${min}–${max}`;
			phoneError.value = `${name} numbers require ${range} digits after the country code`;
		} else {
			phoneError.value = "";
		}
	};

	// Hydrate from an existing value (e.g. when modal reopens)
	if (initialPhoneNumber) {
		const sorted = [...COUNTRIES].sort(
			(a, b) => b.dialCode.length - a.dialCode.length,
		);
		for (const country of sorted) {
			if (initialPhoneNumber.startsWith(country.dialCode)) {
				selected.value = { ...country };
				localNumber.value = initialPhoneNumber.slice(country.dialCode.length);
				break;
			}
		}
		if (!localNumber.value) localNumber.value = initialPhoneNumber;
	}

	watch(localNumber, (val) => {
		const digits = val.replace(/\D/g, "");
		if (phoneError.value && digits.length >= selected.value.min)
			phoneError.value = "";
	});

	watch(selected, () => {
		const digits = localNumber.value.replace(/\D/g, "");
		if (digits) validate();
	});

	// Close picker on outside click
	const handleClickOutside = (e) => {
		if (showCountryPicker.value && !e.target.closest(".phone-input-root")) {
			showCountryPicker.value = false;
		}
	};
	onMounted(() => document.addEventListener("click", handleClickOutside));
	onUnmounted(() => document.removeEventListener("click", handleClickOutside));

	return {
		selected,
		localNumber,
		showCountryPicker,
		search,
		phoneError,
		filtered,
		pick,
		validate,
	};
}
